export function setStorage(key, data) {
  if (data !== null && typeof data === 'object') {
    return localStorage.setItem(key, JSON.stringify(data))
  }
  localStorage.setItem(key, data)
}

export function getStorage(key, defaultValue) {
  const result = localStorage.getItem(key)
  if ((result?.startsWith('{') && result?.endsWith('}')) || (result?.startsWith('[') && result?.endsWith(']'))) {
    return JSON.parse(result)
  }
  if (result === 'true') return true
  if (result === 'false') return false
  return result == 'null' ? defaultValue : result
}

export function removeStorage(key) {
  localStorage.removeItem(key)
}

const BaseStorage = {
  set(value = '', key) {
    setStorage(key || this.key, value)
  },
  get(key, defaultValue) {
    return getStorage(key || this.key, defaultValue)
  },
  clear(key) {
    removeStorage(key || this.key)
  },
}

// 缓存 TabsBar
export const TabsBarStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_TABS_BAR',
})

// 缓存用户信息
export const UserStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_USER_INFO',
})

// 是否需要修改密码
export const ChangePwdStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_IS_CHANGE_PWD',
})

// token
export const TokenStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_X_TOKEN',
})

// webfunny
export const WebFunnyStorage = Object.assign(Object.create(BaseStorage), {
  key: 'wmUserInfo',
})
// 打印模板
export const PrintStorage = Object.assign(Object.create(BaseStorage), {
  key: null,
})
// 用户编号
export const EmployeeNoStorage = Object.assign(Object.create(BaseStorage), {
  key: 'MG_EMPLOYEE_NO',
})
